import { Component, OnInit, OnDestroy } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

import { WriteUsComponent } from "../../components/pop-ups/write-us/write-us.component";
import {knowledgeMenu} from "../../utils/data/knowledge";
import { CommonDataService } from "../../shared/services/common-data.service";
import { environment } from '../../../environments/environment.prod'

@Component({
  selector: "app-knowledge-center",
  templateUrl: "./knowledge-center.component.html",
  styleUrls: ["./knowledge-center.component.scss"],
})
export class KnowledgeCenterComponent implements OnInit, OnDestroy {
  activeTabId = 0;
  showFull = false;
  showTabs = true;
  activeTopicId = 0;
  tabsList: any;
  pageUrl;

  constructor(
    private modalService: NgbModal,
    public commonDataService: CommonDataService,
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.tabsList = knowledgeMenu;
    this.pageUrl = location.href;
    this.scrollTop();
    this.activatedRoute.queryParams.subscribe((qParam) => {
      const context = qParam["context"];
      switch (context) {
        case "Intermediate":
          this.activeTopicId = 1;
          this.setActive(this.activeTopicId, context);
          break;
        case "Advanced":
          this.activeTopicId = 2;
          this.setActive(this.activeTopicId, "Professional");
          break;
        default:
          this.activeTopicId = 0;
      }
    });
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  setActive = (id, val) => {
    this.activeTabId = id;
  };

  setActiveSubTab = (id) => {
    this.activeTopicId = id;
    this.showTabs = false;

    const obj = {
      val: this.tabsList[this.activeTabId].displayName,
      position: "large",
      heading: true,
    };
    this.commonDataService.setSubBreadCrumb(obj);
  };
  setActiveTopic = (id) => {
    this.activeTopicId = id;
  };

  goBack = () => {
    this.showTabs = true;
    this.removeBreadCrumb();
  };

  openPopUp = () => {
    this.modalService.open(WriteUsComponent, {
      size: "lg",
      windowClass: "align-modal-center",
    });
  };

  removeBreadCrumb = () => {
    this.commonDataService.setSubBreadCrumb(null);
  };

  mobileNav = (url) => {
    this.router.navigate([url]);
  };

  investOnline = () => {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://investonline.itiamc.com/", "_blank"); //DR-inv
    }
  };

  ngOnDestroy() {
    this.commonDataService.setSubBreadCrumb(null);
  }
}
